import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "v-tabs" }
const _hoisted_2 = ["onClick"]

import { useResizeObserver } from '@vueuse/core';
import { CSSProperties, nextTick, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'VTabs',
  props: {
    pages: null,
    startPage: null,
    withRouter: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { pages: { [ key: string ]: string }, startPage?: string, withRouter?: boolean }


const page = ref(props.startPage || Object.keys(props.pages)[0])
const markerStyle = ref<CSSProperties>({ transition: "none" })

const tabsRef = ref<HTMLDivElement>()

const calcMarkerPos = (resetTransition = false) => {
  if (!page.value || !tabsRef.value) return
  const index = Object.keys(props.pages).indexOf(page.value)
  const item = tabsRef.value.children[index] as HTMLDivElement
  if (resetTransition) {
    markerStyle.value = { transition: "none", left: item.offsetLeft + "px", width: item.clientWidth + "px" }
  } else {
    markerStyle.value = { left: item.offsetLeft + "px", width: item.clientWidth + "px" }
  }
}

useResizeObserver(tabsRef, () => calcMarkerPos(true))
watch(page, () => calcMarkerPos(false), { flush: "post" })

if (props.withRouter) {
  const router = useRouter()
  onMounted(async () => {
    await new Promise(res => setTimeout(res, 0))
    const type = router.currentRoute.value.params.type
    if (!type || !Array.isArray(type)) return
    if (type.length === 1) {
      const _path = router.currentRoute.value.matched[router.currentRoute.value.matched.length-1].path
      const params = [ router.currentRoute.value.params.type[0], Object.keys(props.pages)[0] ]
      const path = _path.replace(/\:type.?/, params.join("/"))
      router.push(path)
    }
    if (type.length === 2) {
      if (type[1] in props.pages) {
        page.value = type[1]
      }
    }
  })
  watch(page, () => {
    const _path = router.currentRoute.value.matched[router.currentRoute.value.matched.length-1].path
    const params = [ router.currentRoute.value.params.type[0], page.value ]
    const path = _path.replace(/\:type.?/, params.join("/"))
    router.push(path)
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "tabsRef",
      ref: tabsRef,
      class: "v-tabs__tabs"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.pages, (title, key) => {
        return (_openBlock(), _createElementBlock("button", {
          class: _normalizeClass({ active: page.value === key }),
          onClick: ($event: any) => (page.value = (key as string))
        }, _toDisplayString(title), 11, _hoisted_2))
      }), 256)),
      _createElementVNode("div", {
        class: "v-tabs__marker",
        style: _normalizeStyle(markerStyle.value)
      }, null, 4)
    ], 512),
    _renderSlot(_ctx.$slots, page.value)
  ]))
}
}

})